import { getApp, getApps, initializeApp } from "firebase/app";
import { getDatabase, push, ref, set } from "firebase/database";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const isConfigured = Object.values(firebaseConfig).every(Boolean);
const database = isConfigured
  ? getDatabase(getApps().length ? getApp() : initializeApp(firebaseConfig))
  : null;

export const logFirebaseEvent = async (collection, payload) => {
  if (!database || !payload.visitorId) return false;

  try {
    const eventRef = push(ref(database, collection));
    await set(eventRef, {
      ...payload,
      timestamp: Date.now(),
      createdAt: new Date().toISOString(),
    });
    return true;
  } catch (error) {
    if (process.env.NODE_ENV === "development") {
      console.warn(`Firebase ${collection} event was not recorded.`, error.message);
    }
    return false;
  }
};
